import moduleRegistry from './module-registry/module-registry';

// // Online-Catalogue
// import '../../online-cataloge-pages/scripts/modules/main';

// static imports start

import './scrolling/scrolling';

// static imports end

import './abbreviation/abbreviation';
import './accordion-modul/accordion-modul';
import './anchor-section-bar/anchor-section-bar';
import './article-header/article-header';
import './bar-carousel/bar-carousel';
import './card-tiles/card-tiles';
import './category-overview/category-overview';
import './contact-accordion/contact-accordion';
import './cta-button/cta-button';
import './detail-form/detail-form';
import './directory/directory';
import './editorial/editorial';
import './footer/footer';
import './gallery/gallery';
import './image-slider/image-slider';
import './image-video-tile/image-video-tile';
import './interactive-launcher/interactive-launcher';
import './intro/intro';
import './language-form/language-form';
import './lightbox-slider/lightbox-slider';
import './location-map/location-map';
import './media/media';
import './navigation/navigation';
import './navigation/navigation-link-groups';
import './number-overview/number-overview';
import './one-trust-overlay/one-trust-overlay';
import './overlay-footer/overlay-footer';
import './overlay/overlay';
import './paralax-section/paralax-section';
import './search-bar/search-bar';
import './share/share';
import './slim-hero/slim-hero';
import './speciality-hero/speciality-hero';
import './sticky-section/sticky-section';
import './textblock/textblock';
import './timeline/timeline';
import './video-round/video-round';
import './video/video';
import './legal-overlay/legal-overlay';
import './feature-card/feature-cards-carousel';
import './feature-card/feature-card'; 
import './large-image-video-tile/large-image-video-tile';
// import './large-image-video-tile-hero/large-image-video-tile-hero';

// need to be after image video tile
import './carousel-hero/carousel-hero';
// should be last
// import './hover-icon/hover-icon';

window.client = {
    moduleRegistry,
};

(() => {
    const navigatorUserAgentToLowerCase = window.navigator.userAgent.toLowerCase();
    const isChrome = navigatorUserAgentToLowerCase.indexOf('chrome');
    // eslint-disable-next-line no-unused-vars
    const isFirefox = navigatorUserAgentToLowerCase.indexOf('firefox');
    const isSafari = navigatorUserAgentToLowerCase.indexOf('safari');

    if (isSafari !== -1 && isChrome === -1) {
        document.body.setAttribute('class', 'safari');
    }
})();

/**
 // eslint-disable-next-line max-len, max-len
 * @description This function initializes Events for
 * buttons which should initialize the contact vue app
 * @author ALI
 */
(() => {
    const $el = $('*[data-specialist]');

    $el.on('click', (e) => {
        console.log(e);
        const speciality = $el.data('specialist');
        const tabIndex = $el.data('tab-index') || 0;
        const prefilledSpeciality = $el.data('prefilled-speciality') || '';

        if (speciality) {
            window.dispatchEvent(new CustomEvent('ContactAppInit', { detail: { initialTabIndex: tabIndex, speciality: speciality, prefilledSpeciality: prefilledSpeciality } }));

            const html = `<span class="cta-button__icon cta-button__icon--absolute">
                <div class="spinner-loader"></div>
            </span>`;

            $(e.currentTarget).append(html);
        }
    });
})();
